import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@core/store';

import { META_SYNC_STATUS } from './utils/metaIntegrationHelpers';

export type MetaSyncStatus =
  | typeof META_SYNC_STATUS.SYNCING
  | typeof META_SYNC_STATUS.COMPLETED
  | typeof META_SYNC_STATUS.ERROR
  | typeof META_SYNC_STATUS.PARTIAL_SUCCESS;

export interface MetaSyncItem {
  id: string;
  status: MetaSyncStatus;
  timestamp: number;
  error?: string;
  jobId?: string;
}

export interface MetaSyncState {
  items: MetaSyncItem[];
}

const initialState: MetaSyncState = {
  items: []
};

export const metaSyncSlice = createSlice({
  name: 'metaSync',
  initialState,
  reducers: {
    addMetaSync: (
      state,
      action: PayloadAction<{ id: string; jobId: string }>
    ) => {
      const newSync: MetaSyncItem = {
        id: action.payload.id,
        jobId: action.payload.jobId,
        status: META_SYNC_STATUS.SYNCING,
        timestamp: Date.now()
      };
      state.items.push(newSync);
    },
    updateMetaSyncStatus: (
      state,
      action: PayloadAction<{
        id: string;
        status: MetaSyncStatus;
        error?: string;
      }>
    ) => {
      const sync = state.items.find((item) => item.id === action.payload.id);
      if (sync) {
        sync.status = action.payload.status;
        sync.timestamp = Date.now();
        if (action.payload.error) {
          sync.error = action.payload.error;
        }
      }
    },
    removeMetaSync: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
    removeAllMetaSyncs: (state) => {
      state.items = [];
    }
  }
});

export const {
  addMetaSync,
  updateMetaSyncStatus,
  removeMetaSync,
  removeAllMetaSyncs
} = metaSyncSlice.actions;

export default metaSyncSlice.reducer;

export const selectMetaSyncs = (state: RootState) =>
  state.metaSync?.items || [];
